// extracted by mini-css-extract-plugin
export default {"contactItem":"ContactItem_contactItem__3WpW4","icon":"ContactItem_icon__kNc-Y","text":"ContactItem_text__dh6Lu"};